import { render, staticRenderFns } from "./PartnerLearningvideo.vue?vue&type=template&id=d939e6b6&"
import script from "./PartnerLearningvideo.vue?vue&type=script&lang=ts&"
export * from "./PartnerLearningvideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports